module.exports = __webpack_public_path__ + "static/media/f4d-dark.76b93cc7.png";